import React from 'react';
import './UITextareaWithLabel.scss';

export interface UITextareaWithLabelProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /**
   * Лейбл (обов'язковий)
   */
  label: string;

  /**
   * Ширина лейбла в відсотках
   */
  labelWidth?: number;

  /**
   * Додатковий CSS клас
   */
  className?: string;
}

const UITextareaWithLabel: React.FC<UITextareaWithLabelProps> = ({
  label,
  labelWidth,
  className = '',
  ...props
}) => {
  const renderLabel = () => {
    const parts = label.split('*');
    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {part}
        {index < parts.length - 1 && <span className="UITextareaWithLabel__asterisk">*</span>}
      </React.Fragment>
    ));
  };

  const labelStyle = labelWidth ? { flexBasis: `${labelWidth}%` } : {};

  return (
    <div className={`UITextareaWithLabel ${className}`}>
      <label className="UITextareaWithLabel__label" style={labelStyle}>
        {renderLabel()}
      </label>
      <textarea
        className="UITextareaWithLabel__textarea"
        {...props}
      />
    </div>
  );
};

export default UITextareaWithLabel;
